import React from "react";
import {Field} from "formik";
import {getZipCode} from "../../../services/cotizador-service";
import SpecialAdaptationsForm from "../../SpecialAdaptations/SpecialAdaptationsForm";

export function VehicleDataCaptureCard(props) {

    const isAuthenticated = localStorage.getItem("isAuthenticated");
    //Setting model year select input
    const currentTime = new Date();
    const year = currentTime.getFullYear();
    let yearsArray = [];
    for (let i = year + 1; i >= year - 10; i -= 1) yearsArray.push(i);
    return (
        <>
            <div className="col-sm-12 col-md-12 col-lg-7">
                <div className="container card-border p-5" style={{minHeight: '36rem',marginTop: '2rem'}}>
                    <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <label>Tipo de vehículo:</label>
                            <br/>
                            <div className="btn-group radio-toolbar-sekura2 col-12" role="group"
                                 aria-labelledby="radio-group-vehiculo" onClick={()=>{
                                props.clearAllInputs(props.formikValues);
                            }}>
                                <Field type="radio" className="btn-check" name="type"
                                       id="vehiculo-auto" autoComplete="off" value="1"
                                       required/>
                                <label className="btn btn-outline-sekura"
                                       htmlFor="vehiculo-auto"> Auto </label>
                                <Field type="radio" className="btn-check" name="type"
                                       id="vehiculo-pickup" autoComplete="off" value="2"/>
                                <label className="btn btn-outline-sekura"
                                       htmlFor="vehiculo-pickup"> Pickup </label>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6 text-center">
                            <label>Uso:</label>
                            <br/>
                            <div className="btn-group radio-toolbar-sekura1 col-12" role="group"
                                 aria-labelledby="radio-group-uso-vehiculo">
                                <Field type="radio" className="btn-check" name="use"
                                       id="uso-particular" autoComplete="off" value="1" required/>
                                <label className="btn btn-outline-sekura"
                                       htmlFor="uso-particular">Particular</label>
                                {/*
                                <Field type="radio" className="btn-check" name="use"
                                       id="uso-personal" autoComplete="off" value="2"/>
                                <label className="btn btn-outline-dark"
                                       htmlFor="uso-personal">Personal</label>
                                       */}
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <div className="form-group">
                                <label>Año Modelo:</label>
                                <select name="model_year" value={props.formikValues.model_year}
                                        onChange={(e) => {
                                            props.obtainMarks(e, props.formikValues)
                                            if(props.formikValues.model_year >= year-1)
                                                props.formikValues.bill_value = '';
                                        }} className="form-control form-select"
                                        required>
                                    <option value="" selected disabled
                                            onChange={props.handleChange}>Seleccionar...
                                    </option>
                                    {yearsArray.map(option => (
                                        <option key={option} value={option}
                                                onChange={props.handleChange}>
                                            {option}
                                        </option>))}
                                </select>
                            </div>
                        </div>
                        {props.formikValues.model_year == year + 1 ?
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <label>Valor factura:</label>
                                    <Field name="bill_value" type="text"
                                           className="form-control"
                                           placeholder="00.00" required/>
                                </div>
                            </div> :
                            props.formikValues.model_year == year ?
                                <div className="col-sm-12 col-md-6 col-lg-6 text-center"
                                     hidden={props.formikValues.antiquity}>
                                    <label>Valor Factura:</label>
                                    <br/>
                                    <div className="btn-group col-12" role="group"
                                         aria-labelledby="radio-group-factura-ant">
                                        <Field type="radio" className="btn-check"
                                               name="antiquity"
                                               id="menor90" autoComplete="off" value="1"
                                               required/>
                                        <label className="btn btn-outline-sekura"
                                               htmlFor="menor90"
                                               data-toggle="tooltip" title="Menor a 90 días"><i
                                            className="bi-dash-circle"></i> 90
                                            días</label>
                                        <Field type="radio" className="btn-check"
                                               name="antiquity"
                                               id="mayor90" autoComplete="off" value="2"/>
                                        <label className="btn btn-outline-sekura"
                                               data-toggle="tooltip"
                                               title="Mayor a 90 días"
                                               htmlFor="mayor90"><i
                                            className="bi-plus-circle"></i> 90
                                            días</label>
                                    </div>
                                </div> :
                                props.formikValues.model_year <= year - 1 ?
                                    <div className="col-sm-12 col-md-6 col-lg-6">
                                        <div className="form-group">
                                            <label>Valor factura:</label>
                                            <Field type="text" className="form-control bg-skrPrimary text-light text-center"
                                                   value="Valor comercial"
                                                   disabled={true}/>
                                        </div>
                                    </div> :
                                    <div className="col-sm-12 col-md-6 col-lg-6">
                                        <div className="form-group">
                                            <label>Valor factura:</label>
                                            <Field type="text" className="form-control bg-skrPrimary text-light text-center"
                                                   placeholder="00.00" value=""
                                                   disabled={true}/>
                                        </div>
                                    </div>}

                        {props.formikValues.antiquity == 1 && props.formikValues.model_year == year ?
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <label>Valor factura:</label>
                                    <Field name="bill_value" type="text"
                                           className="form-control"
                                           placeholder="00.00" required/>
                                </div>
                            </div> :
                            props.formikValues.antiquity == 2 && props.formikValues.model_year == year ?
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label>Valor factura:</label>
                                        <Field type="text" className="form-control bg-skrPrimary text-light text-center"
                                               value="Valor comercial"
                                               disabled={true}/>
                                    </div>
                                </div> : null}
                    </div>

                    <div className="row mt-3">
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <div className="form-group">
                                <label>Marca:</label>
                                <select name="mark" value={props.formikValues.mark} onChange={(e) => {
                                    props.obtainVersion(e, props.formikValues);
                                }} className="form-control form-select" required>
                                    <option value="" selected disabled
                                            onChange={props.handleChange}>Seleccionar...
                                    </option>
                                    {props.carMark.map(option => (
                                        <option key={option} value={option}
                                                onChange={props.handleChange}>
                                            {option}
                                        </option>))}
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <div className="form-group">
                                <label>Versión:</label>
                                <select name="version" value={props.formikValues.version} onChange={(e) => {
                                    props.obtainResponseFromInsuranceCompany(e, props.formikValues);
                                }} className="form-control form-select" required>
                                    <option value="" selected disabled
                                            onChange={props.handleChange}>Seleccionar...
                                    </option>
                                    {props.carVersion.map(option => (
                                        <option key={option} value={option}
                                                onChange={props.handleChange}>
                                            {option}
                                        </option>))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        {!props.isAuthenticated ?
                        <div className="col-sm-12 col-md-6 col-lg-12">
                            <div className="form-group">
                                <label>Código postal:</label>
                                <Field name="cp" id="cp" onBlur={() => {
                                    getZipCode(props.formikValues.cp);
                                }} minLength="5" maxLength="5" type="text"
                                       className="form-control" placeholder="C.P."
                                       required/>
                            </div>
                        </div> :
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Código postal:</label>
                                    <Field name="cp" id="cp" onBlur={() => {
                                        getZipCode(props.formikValues.cp);
                                    }} minLength="5" maxLength="5" type="text"
                                           className="form-control" placeholder="C.P."
                                           required/>
                                </div>
                            </div>}
                        {/*!props.isAuthenticated ?
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <label htmlFor="InputTel1">Teléfono:</label>
                                    <Field name="phone" type="cel"
                                           className="form-control"
                                           placeholder="No. Teléfono" required/>
                                </div>
                                </div> : null*/}
                    </div>
                    {/*!props.isAuthenticated ?
                        <div className="row mt-2">
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Correo:</label>
                                    <Field name="email" type="email"
                                           className="form-control"
                                           placeholder="Correo electrónico" required/>
                                </div>
                            </div>
                            </div> : null*/}
                    {props.specialAdaptationsFlag === true || !isAuthenticated?
                    <SpecialAdaptationsForm
                        specialAdaptations={props.getSpecialAdaptationsObject}/>: null}
                </div>
            </div>
        </>
    );
}